import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { IoChevronBackSharp, IoChevronForwardSharp } from 'react-icons/io5';
import Navbar from '../../navbar';
import Header from '../../header';
import { fetchApplicationWithId, updateApplication } from '../../../store/reducers/applicationSlice';
import classes from './style.module.css';
import { getstate } from '../../../store/reducers/stateSlice';
import { fetchCategories } from '../../../store/reducers/categoriesSlice';
import { createNotification } from '../../../store/reducers/notificationSlice';
import { setFormFieldData, hideAllPagesExceptCurrentFormPage, goToFormNextPage, goToFormPreviousPage, setPage } from '../../../utility/utility';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker.css';
import { getSignature } from '../../../store/reducers/fileSlice';
import FormLoader from '../../forms/formLoader';
import RejectDialog from "./rejectDialog/rejectDialog";

const ViewApp = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const user = useSelector((state) => state.auth.user);
    const authToken = user?.access_token;
    const { currentApp } = useSelector((state) => state.applications);
    const accessToken = user?.access_token;
    const [formData, setFormData] = useState([]);
    const applicationdata = useSelector((state) => state.applications.currentApp);
    const status = useSelector((state) => state.status.status);
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [formIds, setFormIds] = useState([]);
    const [pageIds, setPageIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoaded, setIsLoaded] = useState(false);
    const [expiryDate, setExpiryDate] = useState(new Date());
    const [signatureImage, setSignatureImage] = useState('');
    const [inputPage, setInputPage] = useState(currentPage);
    const navigate = useNavigate();
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [selectedRejectItem, setSelectedRejectItem] = useState(null);

    useEffect(() => {
        setInputPage(currentPage); // keep input in sync when prop changes
    }, [currentPage]);

    const handleChange = (date) => {
        setExpiryDate(date); // Update the date in the parent component
    };

    const handleOpenReject = (item) => {
        setSelectedRejectItem(item);
        setRejectReason("");
        setShowRejectModal(true);
    };

    const handleCloseReject = () => {
        setShowRejectModal(false);
        setSelectedRejectItem(null);
        setRejectReason("");
    };

    const handleConfirmReject = () => {
        console.log(selectedRejectItem);
        console.log(rejectReason);
        const updatedItem = { ...selectedRejectItem };
        const discrepancies =
            selectedRejectItem.discrepancies && typeof selectedRejectItem.discrepancies === "object"
                ? { ...selectedRejectItem.discrepancies }
                : {};
        discrepancies.other = { value: rejectReason, check: true };
        updatedItem.discrepancies = discrepancies;

        setShowRejectModal(false);
        console.log(updatedItem);
        handleChangeStatus(updatedItem, 5, discrepancies);
    };

    const handleChangeStatus = async (item, state, discrepancies = null) => {
        await dispatch(
            updateApplication({
                id: item?.id,
                state: state,
                descripencie: item.discrepancies,
                json_data: item?.json_data,
                accessToken: accessToken,
            })
        ).then(() => {
            const appName = item.name || 'Application';
            const appId = item.id;
            const statusText = 'Rejected';
            const subject = `Application Status Update: ${appName} (GB-${appId})`;
            const htmlContent = `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #2c3e50;">Application Status Update</h2>
                    <p>Dear User,</p>
                    <p>Your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) has been updated.</p>
                    <p><strong>New Status:</strong> <span style="color: #007bff; font-weight: bold;">${statusText}</span></p>
                    <p>Please log in to your dashboard to view more details.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `;
            dispatch(createNotification({
                message: "Your application " + appName + " (GB-" + appId + ") status has been updated to Rejected.",
                subject: subject,
                htmlMailContent: htmlContent,
                sendToCompanyAdmins: true,
                userId: item.userId || item.user_id,
                accessToken: authToken,
                is_admin: false
            }));
            navigate(`/rejected-applications`);
        });
    };

    const statusvalue = useCallback(async () => {
        if (!params.id || !accessToken) return;
        const data = {
            accessToken: accessToken,
            id: params.id,
        };
        dispatch(fetchApplicationWithId(data));
        dispatch(getstate(accessToken));
        dispatch(fetchCategories({ accessToken: accessToken }))
    }, [params.id, accessToken, dispatch]);

    const selecteddata = async (e) => {

        const filterstatus = await status.filter((item) => item.name === e);
        let dueDate = null;
        await console.log(e)
        if (e === 'approved') {
            setIsOpen(true);
            // setOpenDatePicker(true);
            console.log(expiryDate);
            const currentDateTime = new Date();
            dueDate = currentDateTime.toISOString().split('T')[0];
        }
        if (e === "rejected") {
            handleOpenReject(applicationdata);
            return;
        }


        await dispatch(
            updateApplication({
                accessToken,
                id: params.id,
                state: filterstatus ? filterstatus[0].id : '',
                dueDate,
                json_data: applicationdata?.json_data,
            })
        );
        let statusText = '';
        if (e === 'in_process' || e === 1) statusText = 'In Process';
        else if (e === 'approved' || e === 4) statusText = 'Approved';
        else if (e === 'rejected' || e === 5) statusText = 'Rejected';
        else if (e === 'descrepency_GB_GB' || e === 2) statusText = 'Discrepancies';
        else if (e === 'pending_for_approval' || e === 3) statusText = 'Pending For Approval';
        else if (e === 'renewal' || e === 7) statusText = 'Renewal';
        else statusText = e;

        const appName = applicationdata.name || 'Application';
        const appId = applicationdata.applicationId || applicationdata.id;
        const subject = `Application Status Update: ${appName} (GB-${appId})`;
        const htmlContent = `
            <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                <h2 style="color: #2c3e50;">Application Status Update</h2>
                <p>Dear User,</p>
                <p>Your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) has been updated.</p>
                <p><strong>New Status:</strong> <span style="color: #007bff; font-weight: bold;">${statusText}</span></p>
                <p>Please log in to your dashboard to view more details.</p>
                <br>
                <p>Best regards,</p>
                <p><strong>Gaming Board Team</strong></p>
            </div>
        `;

        dispatch(createNotification({
            message: `Your application ${appName} (GB-${appId}) status has been updated to ${statusText}.`,
            subject: subject,
            htmlMailContent: htmlContent,
            sendToCompanyAdmins: true,
            userId: applicationdata.userId || applicationdata.user_id,
            accessToken: authToken,
            is_admin: false
        }))
        if (e === "descrepency_GB_GB") {
            navigate(`/descrip-applications/${params.id}`);
        } else {
            statusvalue();
        }
    };



    useEffect(() => {
        if (params.id && accessToken) {
            setIsLoaded(false); // Reset loaded state when application ID changes
            setFormData([]); // Reset form data
            setFormIds([]); // Reset form IDs
            setPageIds([]); // Reset page IDs
            setCurrentPage(1); // Reset to first page
            setSignatureImage(''); // Reset signature
            statusvalue();
        }
    }, [params.id, accessToken, statusvalue]);

    useEffect(() => {
        console.log(expiryDate);
    }, [expiryDate])


    useEffect(() => {
        const runAsyncFunctions = async () => {
            if (isLoaded && applicationdata && applicationdata.json_data) {
                await setFormFieldData(applicationdata.json_data);
                let userId = applicationdata.user_id
                let signature = await getSignature({ userId: userId, applicationId: params.id, authToken });
                setSignatureImage(signature);
            }
        };

        runAsyncFunctions();
    }, [isLoaded, applicationdata, params.id, authToken]);

    useEffect(() => {
        if (pageIds && pageIds.length > 0) {
            hideAllPagesExceptCurrentFormPage(pageIds, currentPage);
        }
    }, [pageIds, currentPage])

    useEffect(() => {
        if (formIds && signatureImage && isLoaded) {
            formIds.forEach(id => {
                const inputField = document.getElementById(id);
                if (inputField.type === 'image') {
                    let originalWidth = window.getComputedStyle(inputField).width.replace("px", "")
                    let originalTop = window.getComputedStyle(inputField).top.replace("px", "")
                    let height = (originalWidth * 114) / 179;
                    inputField.style.height = height + "px";
                    inputField.style.top = (originalTop - height) + 20 + "px";
                    inputField.src = signatureImage;
                    inputField.style.objectFit = 'contain'; // Option
                    inputField.style.pointerEvents = 'none'; // Makes the input non-clickable
                }
            });

        }
    }, [signatureImage, isLoaded, formIds])

    return (
        <div>
            <Navbar />
            <Header />
            <div className="wrapper">
                <div className="boxAppBoard boxWhite">
                    <div className="stickyFormHeader">

                        <div className="AppFormBar noShadow">
                            <div className="title">
                                {currentApp?.name}  {formData.find((el) => el.id === currentPage)?.pageName}
                            </div>
                            <div className='pagination'>
                                <div className='pageNum d-flex align-items-center'>
                                    <IoChevronBackSharp onClick={() => goToFormPreviousPage(currentPage, setCurrentPage)} />

                                    <input
                                        type="text"
                                        value={inputPage}
                                        style={{
                                            width: 50,
                                            height: 50,
                                            textAlign: 'center',
                                            color: '#fff',
                                            background: '#323639',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                        }}
                                        onBeforeInput={(e) => {
                                            if (!/^\d$/.test(e.data)) {
                                                e.preventDefault(); // Only allow digit input
                                            }
                                        }}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setInputPage(value); // update local state for controlled input
                                            if (value !== '') {
                                                const pageNum = parseInt(value);
                                                if (!isNaN(pageNum)) {
                                                    setPage(pageNum, currentPage, pageIds, setCurrentPage);
                                                }
                                            }
                                        }}
                                    />

                                    <span className='slash'>{`/`}<span style={{ marginLeft: 10 }}>{pageIds.length}</span></span>
                                    <IoChevronForwardSharp onClick={() => goToFormNextPage(currentPage, pageIds, setCurrentPage)} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="boardHeader">
                        <div className="boardHeadLeft">
                            <h2>In Process Applications</h2>
                        </div>
                        <div className="boardHeadRight">
                            <div>
                                <select
                                    className="form-select"
                                    value={applicationdata?.state || 'All'}
                                    onChange={(e) => {
                                        selecteddata(e.target.value);
                                    }}
                                >
                                    <option disabled value="All">
                                        Select State
                                    </option>
                                    {status.length > 0 &&
                                        status.map((item) => {
                                            const displayText =
                                                item.name === 'in_process' ? 'In Process' :
                                                    item.name === 'descrepency_GB_GB' ? 'Discrepancies' :
                                                        item.name === 'approved' ? 'Approved' :
                                                            item.name === 'rejected' ? 'Rejected' :
                                                                null; // Use null for unmatched cases

                                            return displayText ? (
                                                <option key={item.name} value={item.name}>
                                                    {displayText}
                                                </option>
                                            ) : null; // Return null for unmatched cases
                                        })
                                    }
                                </select>
                            </div>

                        </div>
                    </div>

                    <div className={classes['board-content']}>
                        <FormLoader
                            key={params.id || applicationdata?.id || 'default'} // Force remount when application changes
                            applicationName={applicationdata?.name || ""}
                            setFormIds={setFormIds}
                            setPageIds={setPageIds}
                            setIsLoaded={setIsLoaded}
                        />
                    </div>

                    <RejectDialog
                        open={showRejectModal}
                        reason={rejectReason}
                        setReason={setRejectReason}
                        onReject={handleConfirmReject}
                        onCancel={handleCloseReject}
                    />
                </div>
            </div>




        </div>
    );
};

export default ViewApp;
